module.exports = __webpack_public_path__ + "img/chart.10ef43cc.svg";